import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../../layout";
import { Button } from "../../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import AddEditType from "./AddEditType";
import { API, action, controller } from "../../../api/api";
import { AppContext } from "../../../App";
import { formatDate } from "hooks";

const PaymentTypes = () => {
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const { setLoader, access } = useContext(AppContext);
  const [types, setTypes] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    API(controller.PayType + action.GetAllByOrg).get((res) => {
      res && res.status === 200 && setTypes([...res.result]);
      setLoader(false);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this payment type?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setTypes((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.PayType).Delete(id, onComplete);
      },
    });
  };

  const ActionComp = (val) => (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      {access?.paymentType?.edit && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(val)}
            size="small"
            color="primary"
          >
            <EditRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
      {access?.paymentType?.delete && val.deletable && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(val.id)}
            size="small"
            color="error"
          >
            <ClearRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const HeaderComp = () =>
    access?.paymentType?.create && (
      <div className="flex flex-wrap gap-[10px]">
        <Button onClick={() => handleAddEdit()}>Add Payment Type</Button>
      </div>
    );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: "Name" },
          { id: "link", label: "Getway  Link" },
          { id: "createDate", label: "Create Date" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={types.map((j) => {
          return {
            ...j,
            createDate: formatDate(j.createDate),
            link: (
              <a
                className="link"
                href={j.getway}
                target="_blank"
                rel="noreferrer"
              >
                View Getway
              </a>
            ),
          };
        })}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditType
            {...{ setShowForm: setShowForm, updData, setTypes, setAlert }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default PaymentTypes;
